import React, { FC, memo } from "react";
import { Requests } from "./ServiceTooltip.styles";
import ServiceTooltipItem from "./ServiceTooltipItem";

interface ServiceTooltipsProps {
  zIndex?: number;
  fullWidth?: boolean;
  requests: any;
}

const ServiceTooltips: FC<ServiceTooltipsProps> = ({
  requests,
  zIndex = 9999,
  fullWidth = true,
}) => {
  const requestKeys = Object.keys(requests);

  return (
    <Requests $fullWidth={fullWidth}>
      {requestKeys.map((name) => (
        <ServiceTooltipItem
          key={name}
          name={name}
          status={requests[name]}
          zIndex={zIndex}
        />
      ))}
    </Requests>
  );
};

export default memo(ServiceTooltips);
